/**
 *  Provides the system specific variables form the Env.
 *  Create a file named .env in the root folder of the project and name the variable VUE_APP_* in order to be recognized by VUE CLI.
 */

export default class EnvService {
  /*  all REST-Services for PL start at /pulverlagerliste/
   *  so REST production-url has to be rewritten to /pulverlagerliste/ by the proxy-server
   *  i.e: /produktcenter/ to /pulverlagerliste/
   *  we can't use /pulverlagerliste/ here as this suburl is already in use for the Javascript application
   */
  static get serviceURLOptima() {
    if (process.env.NODE_ENV === 'production')
      return process.env.VUE_APP_URL
      //return 'https://www.kabe-farben.ch/produktcenter/'
    else
    {
      //local  standalone-deployment
      //return 'http://localhost:8082/sdb/'

      //local  tomcat-deployment
      return process.env.VUE_APP_URL
      //return 'http://172.16.4.63:8087/'
    }
  }

  static get serviceURLReporting() {
    if (process.env.NODE_ENV === 'production')
      return process.env.VUE_APP_REPORTING_URL
    else
    {
      //local  tomcat-deployment
      return process.env.VUE_APP_REPORTING_URL
    }
  }
}
